import { useEffect, useState } from 'react'

import { PREFERS_REDUCED_MOTION_QUERY } from 'src/components/constants'

export const usePrefersReducedMotion = (): boolean => {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => window.matchMedia(PREFERS_REDUCED_MOTION_QUERY).matches)

    useEffect(() => {
        const mediaQuery = window.matchMedia(PREFERS_REDUCED_MOTION_QUERY)
        const updatePreference = ({ matches }: MediaQueryList | MediaQueryListEvent) => setPrefersReducedMotion(matches)

        /* the preference can flip between the initial render and this effect, so re-read it while subscribing */
        updatePreference(mediaQuery)
        mediaQuery.addEventListener('change', updatePreference)

        return () => mediaQuery.removeEventListener('change', updatePreference)
    }, [])

    return prefersReducedMotion
}
